<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]
if (!attr.tooltip.formatter) attr.tooltip.formatter = '{b} {c}'

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
  props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras,(res)=> {
        // cptData = res;
        newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let value = item[dataKey[1].value];

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        cptData = newarr; 
              }
             } else { // 如果配置了转换脚本
                cptData = res;
             }
          } else { // 不是数据集类型，是静态数据
               cptData = res;
          } 
  }
function loadChart(attr) {
  if (!cptData) return;
  if (!Array.isArray(cptData))return;
  // console.log(attr.color, 'defaultColor')
  // console.log(attr.series.itemStyle, 'defaultColor1')
  let mapData = []
  cptData.forEach((item,index) => {
    mapData.push({
      value: item.value,
      name: item.name,
      itemStyle: {
        normal: {
          borderColor: 'rgba(0,0,0,0)',
          // shadowColor: attr.color[index],
        },
      },
      label: {
        color: attr.color[index],
        formatter: attr.series.label.formatter || ["{b}", "{c}"].join("\n"),
      },
      tooltip:{
        formatter: attr.tooltip.formatter
      }
    })
  })

  chartOption = {
    color: attr.color,
    title: attr.title,
    tooltip: {
      ...attr.tooltip,
    },
    legend: attr.legend,
    // label: attr.label,
    series: [
      {
        name: attr.title.text,
        type: 'pie',
        roseType: attr.series.roseType === 'false' ? false : attr.series.roseType,
        radius: [attr.series.radius[0] + '%', attr.series.radius[1] + '%'],
        label: attr.series.label,
        itemStyle: attr.series.itemStyle,
        data: mapData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: '#00000000'
          }
        }
      }
    ],

  };
  console.log(chartOption, attr)
  chart.setOption(chartOption);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
